<template>
    <van-row style="padding: 5px 15px;">
        <van-col span="20">
            <van-notice-bar @click="openNoticePopup" class="notice_container" :text="newsText" speed="50">
                <template #left-icon>
                    <img :src="letIconImage" alt="" width="10%">
                </template>
                <template #right-icon>
                    <van-badge v-if="unreadMsgCount > 0" :content="unreadMsgCount">
                        <div class="bell_img" :style="{ background: newsBarStyle.icon_color }">
                            <van-icon name="chat-o" @click="goToMessage" size="22" />
                        </div>
                    </van-badge>
                    <div v-else class="bell_img" :style="{ background: newsBarStyle.icon_color }">
                        <van-icon name="chat-o" @click="goToMessage" size="22" color="transparent" />
                    </div>
                </template>
            </van-notice-bar>
        </van-col>
        <van-col span="4">
            <div class="searchBtn" @click="openGameSearchPopup">
                 <img src="@/assets/themeThree/search_icon.png" alt="" >
            </div>
        </van-col>
    </van-row>

    <NoticePopup ref="NoticePopupRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';
import NoticePopup from './noticePopup.vue';
import { useUserStore } from '@/stores/user';
import { openPopup, safeNavigate } from '@/view/home/supportScript';

const userStore = useUserStore()
const router = useRouter()
const newsBarStyle = ref(
    {
        background_color: "",
        font_color: "",
        icon_color: ""
    }
)
const letIconImage = ref()
const NoticePopupRef = ref();
const unreadMsgCount = computed(() => userStore.unreadCount)
const emits = defineEmits(['goToGameSearch'])
const props = defineProps<{
    itemData: {
        text: string | Record<string, string>,
        styles: {
            background_color: "",
            font_color: "",
            icon_color: ""
        },
        leftIcon_url: ''
    }
}>()

const newsText = computed(() => {
    const text = props.itemData.text
    if (typeof text === 'string') return text
    const lang = localStorage.getItem('lang') || 'en'
    return text[lang] || text['en'] || ''
})

const openNoticePopup = () => {
    openPopup(NoticePopupRef)
}
const goToMessage = (event: Event) => {
    safeNavigate(router, '/sd-message', event)
}
const openGameSearchPopup = () => {
    emits('goToGameSearch')
    
    
}
onMounted(() => {
    newsBarStyle.value.background_color = props.itemData.styles.background_color
    newsBarStyle.value.font_color = props.itemData.styles.font_color
    newsBarStyle.value.icon_color = props.itemData.styles.icon_color
    letIconImage.value = props.itemData.leftIcon_url

})
</script>
<style scoped>
.notice_container {
    font-size: 18px;
    height: 25px;
    padding: 5px 10px;
    margin: 5px 0;
    border-radius: 0.375rem;
    transform: skew(-12deg);
    padding-right: 1rem;
    color: rgb(13, 176, 174);
    background: rgb(0, 33, 33);
    border-top: 0.09375rem solid rgb(245, 200, 76);
    font-weight: bold;

}

.notice_container img {
    width: 30px;
    padding-right: 5px;
}

.bell_img {
    /* background: #f0a853; */
    display: flex;
    align-items: center;
    border-radius: 30px;
    justify-content: center;
    margin-left: 10px;
}

.bell_img img {
    width: 18px;
    padding: 2.5px
}

.notice_container>>>.van-badge {
    border: none;
}

.searchBtn {
    height: 25px;
    padding: 5px 10px;
    margin: 5px;
    border-radius: 0.375rem;
    transform: skew(-12deg);
    padding-right: 1rem;
    background: rgb(0, 33, 33);
    border-top: 0.09375rem solid rgb(245, 200, 76);
}

.searchBtn img {
    width: 100%;
    height: 100%;

}
</style>